/*
  MacShack collection page: live filters, sorting, "Show more" and the mobile filter sheet.
  Results are reloaded with Shopify's Section Rendering API (?section_id=...), so the
  page never fully reloads and filtered views keep a shareable URL.
*/
(function () {
  if (customElements.get('ms-collection')) return;

  var SHEET_QUERY = window.matchMedia('(max-width: 989px)');
  var SWAP = ['[data-ms-results]', '[data-ms-facets-head]', '[data-ms-facets-body]', '[data-ms-facets-foot]'];

  class MsCollection extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.onChange = this.onChange.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onPop = this.onPop.bind(this);
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      this.addEventListener('submit', function (e) {
        if (e.target.matches('[data-ms-form]')) { e.preventDefault(); this.schedule(0); }
      }.bind(this));
      window.addEventListener('popstate', this.onPop);
      this.trackHeader();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.revealCurrentModel.bind(this));
      } else {
        this.revealCurrentModel();
      }
    }

    // On phones the model links scroll sideways; bring the current one into view.
    revealCurrentModel() {
      var list = this.querySelector('.ms-models__list');
      var current = list && list.querySelector('.is-current');
      if (!list || !current || list.scrollWidth <= list.clientWidth) return;
      var lr = list.getBoundingClientRect();
      var cr = current.getBoundingClientRect();
      list.scrollLeft += (cr.left - lr.left) - (lr.width - cr.width) / 2;
    }

    // Desktop sticky filters: keep the column just below the theme's sticky header, which
    // slides away when scrolling down and back in when scrolling up.
    trackHeader() {
      var self = this;
      var header = document.querySelector('.section-header');
      var queued = false;
      // A column taller than the window moves with the page in both directions: scrolling down
      // it travels until its last filter is in view and then sticks; scrolling back up it
      // travels the other way until its first filter is in view and sticks under the header.
      // Nothing inside the column scrolls on its own.
      var lastY = window.scrollY;
      var current = null;
      function update() {
        queued = false;
        var bottom = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
        var maxTop = bottom + 16;
        var column = self.querySelector('.ms-facets');
        var minTop = column ? window.innerHeight - column.offsetHeight - 16 : maxTop;
        var dy = window.scrollY - lastY;
        lastY = window.scrollY;
        if (minTop >= maxTop) {
          current = maxTop;
        } else {
          if (current === null) current = maxTop;
          current = Math.min(maxTop, Math.max(minTop, current - dy));
        }
        self.style.setProperty('--ms-sticky-top', Math.round(current) + 'px');
      }
      this.onScrollHeader = function () {
        if (!queued) { queued = true; requestAnimationFrame(update); }
      };
      window.addEventListener('scroll', this.onScrollHeader, { passive: true });
      window.addEventListener('resize', this.onScrollHeader);
      if (header && window.MutationObserver) {
        // The header animates in/out after its class changes; follow it for the transition.
        this.headerObserver = new MutationObserver(function () {
          var start = performance.now();
          (function follow() {
            update();
            if (performance.now() - start < 600) requestAnimationFrame(follow);
          })();
        });
        this.headerObserver.observe(header, { attributes: true, attributeFilter: ['class'] });
      }
      // The column changes height when filters update or "Show more" opens a long list.
      var column = this.querySelector('.ms-facets');
      if (column && window.ResizeObserver) {
        this.columnObserver = new ResizeObserver(this.onScrollHeader);
        this.columnObserver.observe(column);
      }
      update();
    }

    disconnectedCallback() {
      if (this.columnObserver) this.columnObserver.disconnect();
      window.removeEventListener('scroll', this.onScrollHeader);
      window.removeEventListener('resize', this.onScrollHeader);
      if (this.headerObserver) this.headerObserver.disconnect();
      window.removeEventListener('popstate', this.onPop);
      document.documentElement.classList.remove('ms-lock');
    }

    form() { return this.querySelector('[data-ms-form]'); }

    onChange(e) {
      var t = e.target;
      if (t.matches('.ms-more-toggle') || !t.name) return;
      if (t.matches('[data-ms-band]')) {
        this.applyBand(t);
      } else if (t.matches('[data-ms-price]')) {
        this.querySelectorAll('[data-ms-band]').forEach(function (r) { r.checked = false; });
      } else if (!t.closest('[data-ms-form]') && !t.matches('[data-ms-sort]')) {
        return;
      }
      this.schedule(t.matches('[data-ms-price]') ? 600 : 250);
    }

    applyBand(radio) {
      var parts = radio.value.split('-');
      var group = radio.closest('[data-ms-price-group]');
      var fields = group ? group.querySelectorAll('[data-ms-price]') : [];
      if (fields.length === 2) {
        fields[0].value = parts[0] || '';
        fields[1].value = parts[1] || '';
      }
    }

    buildUrl() {
      var params = new URLSearchParams();
      var form = this.form();
      if (form) {
        new FormData(form).forEach(function (value, key) {
          if (key.indexOf('ms-') === 0 || value === '') return;
          params.append(key, value);
        });
      } else {
        // No filter form (filters off, or none apply): keep the current query (e.g. the search
        // terms) and only change the sort.
        params = new URLSearchParams(window.location.search);
        params.delete('page');
        params.delete('section_id');
        var sort = this.querySelector('[data-ms-sort]');
        if (sort) params.set('sort_by', sort.value);
      }
      var q = params.toString();
      return window.location.pathname + (q ? '?' + q : '');
    }

    schedule(delay) {
      clearTimeout(this.timer);
      this.timer = setTimeout(function () { this.load(this.buildUrl(), true); }.bind(this), delay);
    }

    sectionUrl(url) {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', this.sectionId);
      return u;
    }

    fetchDoc(url) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      // Pass a plain string: some installed apps wrap window.fetch and expect one.
      return fetch(this.sectionUrl(url).toString(), { signal: this.controller.signal, credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }

    load(url, push) {
      var target = new URL(url, window.location.origin);
      target.searchParams.delete('page');
      target.searchParams.delete('section_id');
      this.classList.add('is-loading');
      this.setAttribute('aria-busy', 'true');
      return this.fetchDoc(target.href)
        .then(function (doc) {
          this.swap(doc);
          this.revealResults();
          if (push) {
            try { window.history.pushState({ ms: true }, '', target.pathname + target.search); } catch (e) { /* ignore */ }
          }
        }.bind(this))
        .catch(function (err) {
          if (err.name !== 'AbortError') window.location.href = target.href;
        })
        .finally(function () {
          this.classList.remove('is-loading');
          this.removeAttribute('aria-busy');
        }.bind(this));
    }

    swap(doc) {
      var active = document.activeElement;
      var activeId = active && this.contains(active) ? active.id : null;
      var activeName = active && active.name ? active.name : null;
      var activeValue = active && active.value !== undefined ? active.value : null;
      var scroller = this.querySelector('[data-ms-facets-body]');
      var scrollTop = scroller ? scroller.scrollTop : 0;
      var expanded = Array.prototype.map.call(this.querySelectorAll('.ms-more-toggle:checked'), function (el) { return el.id; });
      var openDetails = [];
      this.querySelectorAll('[data-ms-facets-body] details').forEach(function (d, i) { if (d.open) openDetails.push(i); });

      SWAP.forEach(function (sel) {
        var next = doc.querySelector(sel);
        var current = this.querySelector(sel);
        if (next && current) current.innerHTML = next.innerHTML;
      }, this);

      var details = this.querySelectorAll('[data-ms-facets-body] details');
      openDetails.forEach(function (i) { if (details[i]) details[i].open = true; });
      expanded.forEach(function (id) { var el = document.getElementById(id); if (el) el.checked = true; });
      scroller = this.querySelector('[data-ms-facets-body]');
      if (scroller) scroller.scrollTop = scrollTop;

      var restore = activeId ? document.getElementById(activeId) : null;
      if (!restore && activeName) {
        restore = Array.prototype.find.call(this.querySelectorAll('[name="' + activeName.replace(/"/g, '\\"') + '"]'), function (el) {
          return el.value === activeValue;
        });
      }
      if (restore) restore.focus({ preventScroll: true });
      // In the open filter sheet, never leave focus stranded on <body> after the swap
      // (Escape and the focus trap only work while focus is inside the sheet).
      if (this.classList.contains('is-sheet-open') && !this.contains(document.activeElement)) {
        var title = this.querySelector('.ms-facets__title');
        if (title) { title.setAttribute('tabindex', '-1'); title.focus({ preventScroll: true }); }
      }
      this.syncSheetButton();
    }

    loadMore(link) {
      link.setAttribute('aria-disabled', 'true');
      link.textContent = 'Loading…';
      this.fetchDoc(link.href).then(function (doc) {
        var grid = this.querySelector('[data-ms-grid]');
        var incoming = doc.querySelectorAll('[data-ms-grid] > [data-ms-card]');
        var first = null;
        incoming.forEach(function (card) {
          var node = document.importNode(card, true);
          grid.appendChild(node);
          if (!first) first = node;
        });
        var wrap = this.querySelector('[data-ms-more-wrap]');
        var nextWrap = doc.querySelector('[data-ms-more-wrap]');
        if (wrap) wrap.innerHTML = nextWrap ? nextWrap.innerHTML : '';
        var firstLink = first && first.querySelector('a');
        if (firstLink) firstLink.focus({ preventScroll: true });
      }.bind(this)).catch(function (err) {
        if (err.name !== 'AbortError') window.location.href = link.href;
      });
    }

    onClick(e) {
      var more = e.target.closest('a[data-ms-more]');
      if (more) { e.preventDefault(); if (more.getAttribute('aria-disabled') !== 'true') this.loadMore(more); return; }
      var link = e.target.closest('a[data-ms-link]');
      if (link) { e.preventDefault(); this.load(link.href, true); return; }
      if (e.target.closest('[data-ms-open]')) { this.openSheet(); return; }
      if (e.target.closest('[data-ms-close]')) { this.closeSheet(); }
    }

    onKey(e) {
      var more = e.target.closest && e.target.closest('.ms-more-label');
      if (more && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        var t = document.getElementById(more.getAttribute('for'));
        if (t) { t.checked = true; var firstExtra = more.parentNode.querySelector('.ms-pill.is-extra input'); if (firstExtra) firstExtra.focus(); }
        return;
      }
      if (!this.classList.contains('is-sheet-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); this.closeSheet(); return; }
      if (e.key !== 'Tab') return;
      var panel = this.querySelector('[data-ms-panel]');
      var focusable = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, summary, [tabindex]:not([tabindex="-1"])');
      var list = Array.prototype.filter.call(focusable, function (el) { return el.offsetParent !== null || el.matches('input'); });
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    onPop() {
      this.load(window.location.href, false);
    }

    openSheet() {
      if (!SHEET_QUERY.matches) return;
      var panel = this.querySelector('[data-ms-panel]');
      this.lastFocus = document.activeElement;
      this.classList.add('is-sheet-open');
      document.documentElement.classList.add('ms-lock');
      document.documentElement.style.overflow = 'hidden';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      this.syncSheetButton();
      // Move focus into the sheet without drawing a focus ring on a button the user didn't press.
      var title = panel.querySelector('.ms-facets__title');
      if (title) {
        title.setAttribute('tabindex', '-1');
        setTimeout(function () { title.focus({ preventScroll: true }); }, 50);
      }
    }

    // After filtering, the list is often much shorter, so the browser can be left showing the
    // content below the grid. Bring the top of the results back into view, just under the
    // theme header. On phones this waits until the filter sheet is closed.
    revealResults() {
      if (this.classList.contains('is-sheet-open')) { this.pendingReveal = true; return; }
      this.pendingReveal = false;
      var layout = this.querySelector('.ms-layout') || this;
      var top = layout.getBoundingClientRect().top;
      var header = document.querySelector('.section-header');
      var offset = (header ? header.offsetHeight : 0) + 16;
      if (top >= 0 && top < window.innerHeight) return; // already in view
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var y = window.scrollY + top - (top < 0 ? offset : 16);
      window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    }

    closeSheet() {
      if (!this.classList.contains('is-sheet-open')) return;
      var panel = this.querySelector('[data-ms-panel]');
      this.classList.remove('is-sheet-open');
      document.documentElement.classList.remove('ms-lock');
      document.documentElement.style.overflow = '';
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      this.syncSheetButton();
      var opener = this.querySelector('[data-ms-open]');
      (opener || this.lastFocus || document.body).focus({ preventScroll: true });
      if (this.pendingReveal) this.revealResults();
    }

    syncSheetButton() {
      var opener = this.querySelector('[data-ms-open]');
      if (opener) opener.setAttribute('aria-expanded', this.classList.contains('is-sheet-open') ? 'true' : 'false');
    }
  }

  customElements.define('ms-collection', MsCollection);

  SHEET_QUERY.addEventListener && SHEET_QUERY.addEventListener('change', function (e) {
    if (!e.matches) {
      document.querySelectorAll('ms-collection.is-sheet-open').forEach(function (el) { el.closeSheet(); });
    }
  });
})();
